import { render, staticRenderFns } from "./tipsPage.vue?vue&type=template&id=d6e147fc&scoped=true"
import script from "./tipsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./tipsPage.vue?vue&type=script&setup=true&lang=js"
import style0 from "./tipsPage.vue?vue&type=style&index=0&id=d6e147fc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6e147fc",
  null
  
)

export default component.exports